<template>
  <div class="about">
    <div class="about-body">
      <div class="about-left">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          @select="handleMenuItemClick"
          background-color="rgb(230, 230, 230)"
        >
          <el-menu-item index="1">
            <i class="el-icon-s-platform"></i>
            <span slot="title">业务范围</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-star-off"></i>
            <span slot="title">相关产品</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="about-right">
        <div>
          <ComputerItem :data="newsData1[0]" />
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from "../components/SiteFooter.vue";
import ComputerItem from "../components/ComputerItem.vue";
export default {
  components: { SiteFooter, ComputerItem },
  data() {
    return {
      activeIndex: "1",
      //测试数据
      newsData1: [
        {
          id: 1,
          title: "业务范围",
          time: "2023-07-07 17:46:00",
          text: [
            "1、中小型水电站优化运行方案设计及管理系统设计研发；",
            "2、中小型水电站在线监测与远程故障诊断系统设计研发；",
            "3、中小型水库优化调度系统设计研发；",
            "4、中小型水电站设计、技术改造；",
            "5、工程防洪评价、水资源评价；",
            "6、中小型水利工程相关水土保持设计；",
            "7、水利行业各实用技术及技术方案的制定等;",
          ],
          images: "",
        },
      ],
    };
  },
  methods: {
    handleMenuItemClick(index, indexPath) {
      console.log("点击了菜单项:", index, indexPath);
      // 在这里添加你的点击处理逻辑

      if (index === "1") {
        this.newsData1[0].title = "业务范围";
        this.newsData1[0].text = [
          "1、中小型水电站优化运行方案设计及管理系统设计研发；",
          "2、中小型水电站在线监测与远程故障诊断系统设计研发；",
          "3、中小型水库优化调度系统设计研发；",
          "4、中小型水电站设计、技术改造；",
          "5、工程防洪评价、水资源评价；",
          "6、中小型水利工程相关水土保持设计；",
          "7、水利行业各实用技术及技术方案的制定等;",
        ];
      } else if (index === "2") {
        this.newsData1[0].title = "相关产品";
        this.newsData1[0].text = [
          "公司产品包括水利行业相关的一些设备，水电站的设计工程及图纸，水电站优化运行，水电站故障诊断，生态电站的方案和软硬件等。",
        ];
      } else {
        console.log("11111");
      }
    },
  },
};
</script>

<style scoped>
.about {
  width: 100%;
  height: 590px;
  margin: 20px 0 0 0;
}
.about-body {
  display: flex;
  justify-content: space-between;
}
.about-left {
  width: 25%;
  height: 590px;
  background-color: rgb(230, 230, 230);
  border-right: 1px solid #ededed;
}
.about-right {
  width: 75%;
  height: 590px;
  background-color: rgb(230, 230, 230);
}
.el-menu-vertical-demo {
  height: 90%;
  margin: 20px;
}
</style>